import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const TransformationSection = () => {
  return <section className="bg-terracotta text-white px-4 py-10 md:py-20 lg:px-8" data-id="element-237">
      <div className="mx-auto max-w-5xl" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-239">
          <h2 className="mb-8 font-serif text-3xl font-bold md:text-5xl" data-id="element-240">
            What if dinner time looked like this instead?
          </h2>
          <div className="mx-auto max-w-3xl space-y-6 text-lg leading-relaxed md:text-xl" data-id="element-241">
            <p data-id="element-242">
              Instead of fighting the clock, you simply activate your protected
              dinner and you're done. You get to cuddle your kids, talk to your
              spouse, and stop stressing about time. You have way fewer dishes
              to wash, so you actually finish in the kitchen early for once.
            </p>
            <p className="font-bold text-highlight" data-id="element-243">
              Friend, you can absolutely get dinner on the table every single
              night without feeling like you're ready to pull your hair out. I
              know it because I've been there!
            </p>
          </div>
        </motion.div>

        {/* Testimonial Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl rounded-2xl bg-white/10 p-8 backdrop-blur-sm md:p-10" data-id="element-244">
          <div className="mb-6 flex justify-center space-x-1" data-id="element-245">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" data-id="element-246" />)}
          </div>

          <blockquote className="mb-6 text-center text-lg italic leading-relaxed text-white/90 md:text-xl" data-id="element-247">
            "Wonderful! I'm new to meal prep, but as a working mom, I needed
            help. I love to cook but don't have time. This guide didn't just
            make my life easier; my very picky son loves almost every dish! The
            Freshness Shield really makes the food taste like it was just made
            from scratch."
          </blockquote>

          <div className="text-center font-bold text-highlight" data-id="element-248">
            — Claudia, Full Bundle purchaser.
          </div>
        </motion.div>
      </div>
    </section>;
};